<template lang="pug">
v-app-bar.elevation-1.white(:height="height", ref="header")
  v-container.main-header-desktop.pt-0.h-100
    router-link.white--text.h-100(to="/")
      img.logo.main-header-desktop-logo(:src="logo", contain, height="100%")
    top.ml-auto
    nav-menu.ml-auto.pb-5(:menu="menu")
</template>

<script>
import NavMenu from "./NavMenu";
import Top from "./Top";
import { getWhatsappLinkFromPhone } from "@/components/utils";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    logo() {
      return this.files + this.$rest("informations").item.img;
    },
    whatsappLink() {
      return getWhatsappLinkFromPhone(
        this.$rest("informations").item.whatsapp || ""
      );
    },
    height() {
      return 146;
    },
  },
  components: {
    NavMenu,
    Top,
  },
};
</script>

<style>
.main-header-desktop {
  display: grid;
  grid-template: "logo . top" "logo . nav" / max-content auto max-content;
  row-gap: 20px;
  align-items: center;
}
.main-header-desktop > :nth-child(1) {
  grid-area: logo;
}
.main-header-desktop > :nth-child(2) {
  grid-area: top;
}
.main-header-desktop > :nth-child(3) {
  grid-area: nav;
}

.v-app-bar {
  z-index: 999;
}

@media screen and (min-width: 960.001px) and (max-width: 1264px) {
  .main-header-desktop {
    grid-template: "logo top" "nav nav" / max-content auto;
  }
  .main-header-desktop-logo {
    max-width: 214px !important;
    padding-top: 10px;
  }
}
</style>
